import { BrowserRouter as Router } from 'react-router-dom'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-datepicker'
import { HelveticaForTarget } from '@praxis/component-font'
import { AuthProvider } from '@praxis/component-auth'

import './globalStyles/customStyles.scss'
import { Main } from './views/Main'
import apiConfig from './globalConfig/apiConfig'
import { EnvProvider } from '@praxis/component-runtime-env'

const App = () => {
  return (
    <EnvProvider
      configPath={
        process.env.NODE_ENV === 'development'
          ? '/config.json'
          : '/app-environment'
      }
    >
      <HelveticaForTarget variants={['n4', 'n5', 'n7']} />
      <Router>
        <AuthProvider {...apiConfig.auth}>
          <Main />
        </AuthProvider>
      </Router>
    </EnvProvider>
  )
}

export default App
